const useAddRoleStyles = () => {
    return {
        main: {
            display: 'flex',
            flexDirection: 'column',
            borderRadius: (theme) => theme.spacing(4),
            gap: 1.5,
            height: 'auto'
        },
        buttonText: {
            color: (theme) => theme.palette.primary.main
        },
        actions: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: (theme) => theme.spacing(1),
            mb: (theme) => theme.spacing(1)
        }
    };
};
export default useAddRoleStyles;
